export default "__VITE_ASSET__DcFLaipy__"